<main class="legal-page">
  <div class="top-row">
    <button type="button" class="back-btn" aria-label="Wstecz" (click)="goBack()">
      <sz-icon name="arrow-back" [size]="20" />
    </button>
    <sz-brand-block [compact]="true" />
  </div>

  <div class="legal-head">
    <div class="legal-head__kicker">Dokument</div>
    <h1 class="legal-head__title">Regulamin <span class="legal-head__accent">SplitZero.</span></h1>
  </div>

  <article class="legal-body">
    <h2>§1 Definicje</h2>
    <ol>
      <li><strong>Aplikacja</strong> - aplikacja mobilna „SplitZero” dostępna na urządzenia mobilne.</li>
      <li>
        <strong>Usługodawca</strong> - DEV-TECH Infiniti Sp. z o.o.<br />
        ul. Fryderyka Chopina 41/2<br />
        20-023 Lublin, Polska<br />
        NIP: 7123461831<br />
        KRS: 0001059611<br />
        REGON: 526449543<br />
        E-mail: <a href="mailto:office@dev-infiniti.pl">office&#64;dev-infiniti.pl</a>
      </li>
      <li><strong>Użytkownik</strong> - osoba korzystająca z Aplikacji.</li>
      <li><strong>Konto</strong> - konto Użytkownika umożliwiające korzystanie z funkcji Aplikacji.</li>
    </ol>

    <h2>§2 Postanowienia ogólne</h2>
    <ol>
      <li>SplitZero jest aplikacją służącą do organizowania i logowania treningów strzeleckich.</li>
      <li>
        Aplikacja umożliwia:
        <ul>
          <li>tworzenie drillów treningowych,</li>
          <li>planowanie treningów,</li>
          <li>logowanie sesji treningowych,</li>
          <li>śledzenie historii treningów.</li>
        </ul>
      </li>
      <li>Aplikacja ma charakter wyłącznie treningowo-organizacyjny.</li>
      <li>Usługodawca nie ponosi odpowiedzialności za sposób korzystania z broni palnej przez Użytkowników.</li>
      <li>
        Użytkownicy są zobowiązani do przestrzegania obowiązujących przepisów prawa oraz zasad bezpieczeństwa
        obowiązujących na strzelnicach.
      </li>
    </ol>

    <h2>§3 Konto użytkownika</h2>
    <ol>
      <li>Konto może zostać utworzone przez e-mail, Google lub Apple.</li>
      <li>Użytkownik odpowiada za bezpieczeństwo swojego Konta.</li>
      <li>Konto może zostać usunięte w dowolnym momencie.</li>
    </ol>

    <h2>§4 Odpowiedzialność</h2>
    <ol>
      <li>Aplikacja nie stanowi instrukcji używania broni ani szkolenia strzeleckiego.</li>
      <li>Usługodawca nie odpowiada za szkody wynikające z nieprawidłowego korzystania z broni palnej.</li>
    </ol>

    <h2>§5 Dane osobowe</h2>
    <ol>
      <li>Administratorem danych jest DEV-TECH Infiniti Sp. z o.o.</li>
      <li>Szczegóły znajdują się w Polityce Prywatności.</li>
    </ol>

    <h2>§6 Kontakt</h2>
    <p>
      <a href="mailto:office@dev-infiniti.pl">office&#64;dev-infiniti.pl</a>
    </p>
  </article>
</main>
